module.exports = __webpack_public_path__ + "static/media/camera.de58a93e.svg";